import fetch from './Fetch';

export default class NavigationApi {
    static async getPlatformList() {
        const url = '/_cloud/platforms/list';
        return fetch(url)
            .then(({ response }) => response.json().then((body) => ({ response, body: body.platforms })));
    }
}
